<template>
    <div class="datagrid-wrapper">
        <div class="row">
            <div class="col-md-12 title-holder">
                <h2>{{ table_title }}</h2>
                <div data-type="buttons" class="sub-grid-buttons">
                    <a v-if="filter_button_clicked === false" href="#" @click="filter()" class="btn btn-light">
                        Show with and without E-lock
                    </a>
                    <a v-else href="#" @click="filter()" class="btn btn-light">
                        Show only with E-lock
                    </a>
                </div>
                <div class="search-form-mask open">
                    <form role="search" method="get" class="form-inline search-form">
                        <div class="form-group">
                            <input v-model.lazy="search" class="sb-search-input form-control"
                                   placeholder="Search for.."/>
                        </div>
                        <div v-if="this.search">
                            <button @click.prevent="reset" type="reset" class="btn-icon btn-light sb-icon-reset">
                                <span class="fa fa-close">
                                    <span class="visually-hidden">Reset</span>
                                </span>
                            </button>
                        </div>
                        <button @click.prevent="getCompanyAccess" type="submit" class="btn btn-light sb-icon-search">
                            <span class="fa fa-search">
                                <span class="visually-hidden">Search</span>
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>

        <div class="row description">
            <div class="col-md-12">
                <p>These Access items are generated based on the companies renting a space. Access is only enabled for a contracted period.</p>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <table class="datagrid table">
                    <thead>
                    <tr>
                        <th v-for="header in table_headers">
                            <div v-if="header === 'description'">
                                <button type="button" class="btn btn-link"  @click="sortBy('rule_name')">
                                    {{ header }} &#8597;
                                </button>
                            </div>
                            <div v-else-if="header === 'from'">
                                <button type="button" class="btn btn-link" @click="sortBy('bookings.start_date')">
                                    {{ header }} &#8597;
                                </button>
                            </div>
                            <div v-else-if="header === 'until'">
                                <button type="button" class="btn btn-link" @click="sortBy('bookings.end_date')">
                                    {{ header }} &#8597;
                                </button>
                            </div>
                            <div v-else class="table-header">
                                <span class="btn-link">{{ header }}</span>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!bookings.data">
                        <td :colspan="table_headers.length"><span class="spinner anim-spin"></span></td>
                    </tr>
                    <tr v-else-if="!bookings.data.length">
                        <td :colspan="table_headers.length">No results found</td>
                    </tr>
                    <tr v-for="booking in bookings.data" v-bind:key="booking.id">
                        <td v-for="column in table_columns">
                            <div v-if="column === 'rule_name'">
                                <a :href="`/centre/access/company/${booking.id}`">{{ booking.rule_name }}</a>
                            </div>
                            <div v-else-if="column === 'start_date' || column === 'end_date'">
                                <span>{{ $formatDate(booking[column], user_date_format, 'HH:mm') }}</span>
                            </div>
                            <div v-else-if="column === 'status'" v-html="statusHtml(booking.status)"></div>
                            <div v-else-if="column === 'action' && can_sync_booking">
                                <a :data-booking-id="`${booking.id}`" :href="`/centre/${booking.centre_id}/manual-sync/${booking.id}/modal`"
                                       class="sync-single-booking btn btn-link link-button">Sync</a>
                            </div>
                            <div v-else>
                                {{ booking[column] }}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            <pagination :data="bookings" :limit=3 @pagination-change-page="getCompanyAccess">
                                <template #prev-nav>
                                    <span>&lt; Previous</span>
                                </template>
                                <template #next-nav>
                                    <span>Next &gt;</span>
                                </template>
                            </pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CompanyBasedAccessDataTable",
    props: {
        api_endpoint: {
            type: String,
        },
        table_title: {
            type: String,
        },
        table_headers: {
            type: Array,
        },
        table_columns: {
            type: Array,
        },
        user_date_format: {
            type: String,
        },
        can_sync_booking: {
            type: Boolean,
        },
    },
    data() {
        return {
            bookings: {},
            paginate: 10,
            search: '',
            filter_button_clicked : false,
            sort_key: '',
            reverse: false,
        }
    },
    watch: {
        paginate: function () {
            this.getCompanyAccess();
        },
        search: function search() {
            this.getCompanyAccess()
        },
    },
    methods: {
        statusHtml(status) {
            let statusTextCss = status === 'expired' ? 'danger' : status;

            return '<span class="text-' + statusTextCss +'">' + status + '</span>';
        },
        filter() {
            this.filter_button_clicked = !this.filter_button_clicked;
            this.getCompanyAccess();
        },
        getCompanyAccess(page = 1) {
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    paginate: this.paginate,
                    q: this.search,
                    show_lock: this.filter_button_clicked ? 'both' : 'with',
                    sort_key: this.sort_key,
                    sort_direction: this.reverse ? 'DESC' : 'ASC',
                }
            })
            .then(response => {
                this.bookings = response.data;
            });
        },
        reset() {
            this.search = '';
        },
        sortBy(sort_key) {
            this.reverse = (this.sort_key === sort_key) ? ! this.reverse : false;
            this.sort_key = sort_key;
            this.getCompanyAccess();
        },
    },
    mounted() {
        this.getCompanyAccess();
    }
}
</script>
<style scoped>
.btn-link,.btn-link:hover {
    letter-spacing: normal;
    padding: 0 30px 0 0;
    margin: 0;
    vertical-align: bottom;
    color: #babfbf;
    font-weight: bold;
    font-size: 11px;
    outline: none !important;
    border: 0;
    text-decoration: none;
}
</style>

